export const EmptyCell = () => <div>-</div>